import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../UsuariosAtencionACliente/CuadroAtencionAClienteComponent.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faPlus
} from '@fortawesome/free-solid-svg-icons'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux'
import AtencionAClienteFormComponent from '../UsuariosAtencionACliente/AtencionAClienteFormComponent'
import CuadroAtencionAClienteComponent from '../UsuariosAtencionACliente/CuadroAtencionAClienteComponent'
import UsuariosComponent from '../UsuariosAtencionACliente/UsuariosComponent'
import { obtenerCarteras, obtenerUsuariosAtencionACliente } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import CarterasComponent from '../Carteras/CarterasComponent'
library.add(faPlus)

function PanelAtencionACliente(props) {
    const dispatch = useDispatch()

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        height: 600,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        'overflowY': 'scroll',
    };

    const usuariosAtencionAClientes = useSelector(store => store.UsuariosAtencionACliente.usuariosAtencionACliente)
    const dataCartera = useSelector(store => store.UsuariosAtencionACliente.dataCartera)

    const [open, setOpen] = React.useState(false);
    const [usuarioModify, setUsuarioModify] = React.useState(null)
    const [carteras, setCarteras] = React.useState(null)

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setUsuarioModify(null)
        setCarteras(null)
        setOpen(false)
    }

    const handleModify = async (usuario) => {
        handleOpen()
        setUsuarioModify(usuario)
        const carteras = await dispatch(obtenerCarteras())
        setCarteras(carteras.payload)
    }
    React.useEffect(async () => {
        await dispatch(obtenerUsuariosAtencionACliente())
    }, [])



    const [apartados, setApartados] = React.useState('Cartera');
    const handleChangeApartado = (event, newValue) => {
        setApartados(newValue);
    };
    return (
        <Fragment>
            <Box sx={{ width: '90%', typography: 'body1', marginTop: '3%', marginLeft: '5%' }}>
                <TabContext value={apartados}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        textAlign: 'center', backgroundColor: '#fcfcfc',
                        boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                    }}>
                        <TabList onChange={handleChangeApartado} aria-label="lab API tabs example" className='text-center'
                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                            sx={{
                                "& button": { color: '#CD973D', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                "& button:hover": { color: '#CD973D', transform: 'scale(1.1)' },
                                "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                            }}>
                            <Tab label="Carteras" value="Cartera" />
                            <Tab label="Usuarios Atención a Cliente" value="Atencion" />
                        </TabList>
                    </Box>
                    <TabPanel value="Cartera">
                        <div className='row'>
                            <CarterasComponent />
                        </div>
                    </TabPanel>
                    <TabPanel value="Atencion">
                        <div className='row'>
                            <div className='container'>
                                <h1 className='text-center tm'>Usuarios de atención a clientes</h1><br />
                                <div className={`text-end col-md-12`} style={{ marginTop: '-3%' }}>
                                    <button className={`btn btn-outline-success btn-sm ${estilos.zoom}`} onClick={handleOpen}>Agregar nuevo usuario</button>
                                </div><br />
                                {usuariosAtencionAClientes &&
                                    <UsuariosComponent usuarios={usuariosAtencionAClientes.filter(usuario => usuario?.datoslogin?.estatus == true)} dataCartera={dataCartera} onModify={handleModify} />
                                }
                            </div>
                        </div>
                    </TabPanel>
                </TabContext>
            </Box>
            {/* style={{ maxWidth: 1600, paddingLeft: '10%' }} */}



            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <Box sx={style}>
                            <AtencionAClienteFormComponent usuarioModify={usuarioModify} onClose={handleClose} carteras={carteras}></AtencionAClienteFormComponent>
                        </Box>
                    </Fade>
                </Modal>
            </div>
        </Fragment>
    );
};


export default withRouter(PanelAtencionACliente)
